import React, { useEffect, useState } from "react";
import useLogout, { isValidEmail } from "../../../utils/Utils";
import { useForm } from "react-hook-form";
import Head from "../../../layout/head/Head";
import Content from "../../../layout/content/Content";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PreviewAltCard,
  Row,
} from "../../../components/Component";
import Select from "react-select";
import { Badge, Form, Label } from "reactstrap";
import MyButton from "../../../myComponents/form/MyButton";
import Status from "../../../myComponents/form/Status";
import {
  createLMSAdminAPI,
  getClassDD,
  getDistrictByDivisionDDAPI,
  getDivisionDDAPI,
  getLMSUserListPI,
  getRoleListAPI,
  getStreamByClassDD,
  getSubjectByClassLMSDD,
  updateLMSAdminAPI,
} from "../../../api/LMS/master";
import { toast } from "react-toastify";
import Required from "../../../myComponents/validate/Required";
import { generatePassword, hasPermission } from "../../../utils/myFunctions";
import { roles } from "../../../assets/constants/constants";
import MyDataTable from "../../../myComponents/DataTable/MyDataTable";
import { useLocation, useNavigate } from "react-router";
import { decrypt } from "../../../utils/Encrypt";

const ManageUser = () => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState("Add");
  const [isLoading, setIsLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [classList, setClassList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [streamList, setStreamList] = useState([]);
  const [columns, setColumns] = useState([
    {
      name: "Role",
      selector: (row) => row?.role,
      cell: (row) => row?.role,
      sortable: true,
    },
    {
      name: "Division",
      selector: (row) => row?.division,
      cell: (row) => row?.division,
      sortable: true,
    },
    {
      name: "District",
      selector: (row) => row?.district,
      cell: (row) => row?.district,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      cell: (row) => row?.name,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      cell: (row) => row?.email,
      sortable: true,
    },
    {
      name: "Mobile",
      selector: (row) => row?.phoneNumber,
      cell: (row) => row?.phoneNumber,
      sortable: true,
    },
    {
      name: "Password",
      selector: (row) => row?.password,
      cell: (row) => row?.password,
      sortable: true,
    },
    {
      name: "Status",
      selector: (row) => row?.status,
      cell: (row) => (
        <div style={{}}>
          <Badge color={`${row.status == "active" ? "success" : "danger"}`}>
            {row.status == "active" ? "Active" : "Inactive"}
          </Badge>
        </div>
      ),
      sortable: true,
      wrap: true,
    },
    {
      name: "Action",
      wrap: true,
      cell: (row) => (
        <div>
          {isUpdate && (
            <>
              {row.role === "admin" ? null : (
                <Button outline color="warning" size="xs" className="me-1" onClick={() => handleEdit(row)}>
                  <Icon name="edit" />
                </Button>
              )}
              {row?.role == "District" || row?.role == "IT Admin" || row?.role == "Division"||row?.role=="Subject Specialist" ? (
                <Button outline color={"primary"} size={"xs"} className={"me-1"} onClick={() => handlePermission(row)}>
                  <Icon name={"account-setting-fill"} />
                </Button>
              ) : null}
            </>
          )}
        </div>
      ),
    },
  ]);
  const location = useLocation();
  const enc = JSON.parse(localStorage.getItem("userDetail"));
  const user = decrypt(enc?.data || []);
  console.log(user,"user");
  
  const isView = hasPermission(user, location?.pathname, "isView");
  const isUpdate = hasPermission(user, location?.pathname, "isUpdate");
  const isDelete = hasPermission(user, location?.pathname, "isDelete");
  const isCreate = hasPermission(user, location?.pathname, "isCreate");
  const [timer, setTimer] = useState(5); // 5 seconds countdown
  useEffect(() => {
    if (!isView) {
      const interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
      // redirect to home page when the timer reaches 0
      if (timer === 0) {
        navigate(-1);
      }
      // clean up the interval when the component unmounts
      return () => clearInterval(interval);
    } else {
      setIsLoading(false);
    }
  }, [timer]);
  const logout = useLogout();
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      roleList: roles,
      role: null,
      divisionList: [],
      division: null,
      districtList: [],
      district: null,
      password: generatePassword(),
      userList: [],
      status: { value: "active", label: "Active" },
    },
  });
  useEffect(() => {
    getUserList();
  }, []);
  const getDivision = () => {
    const data = {};
    getDivisionDDAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setValue("divisionList", res.data.data);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("divisionList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getUserList = (data) => {
    setIsLoading(true);
    getLMSUserListPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setValue("userList", res.data.data);
          toast.clearWaitingQueue();
          setIsLoading(false);
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("userList", []);
          setIsLoading(false);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const getDistrict = (data) => {
    getDistrictByDivisionDDAPI(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          toast.success(res.data.message);
          setValue("districtList", res.data.data);
          toast.clearWaitingQueue();
        } else if (!status) {
          toast.warning(res.data.message);
          toast.clearWaitingQueue();
          setValue("districtList", []);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleRoleChange = (opt) => {
    setValue("role", opt);
    setValue("division", null);
    setValue("district", null);
    setValue("name", "");
    if (opt?.value == "JD" || opt?.value == "DIOS" || opt?.value == "District" || opt?.value == "Division") {
      getDivision();
    }
    if (opt?.value == "Subject Specialist") {
      getDivision();
      getClass();
    }
    if (opt?.value == "IT Admin") {
      setValue("name", "IT Admin");
    }
    if (opt?.value == "State") {
      setValue("name", "State");
    }
  };
  const handleDivisionChange = (opt) => {
    setValue("division", opt);
    setValue("district", null);
    const body = {
      division_id: opt?.value,
    };
    if (watch("role")?.value == "JD" || watch("role")?.value == "Division") {
      setValue("name", `JD ${opt?.label}`);
    }

    getDistrict(body);
  };
  const handleDistrictChange = (opt) => {
    setValue("district", opt);
    if (watch("role")?.value == "DIOS") {
      setValue("name", `DIOS ${opt?.label}`);
    }
    if (watch("role")?.value == "District") {
      setValue("name", watch("row")?.name);
    }
  };
  const createPassword = () => {
    const pass = generatePassword();
    setValue("password", pass);
  };
  const onFormSubmit = (data) => {
    const role = watch("role")?.value;
    const body = {
      phoneNumber: watch("mobile_no"),
      password: watch("password"),
      name: watch("name"),
      role,
      email: watch("email"),
      status: watch("status")?.value,
      ...(role === "JD" || role === "DIOS" || role == "District" || role == "Division" || role == "Subject Specialist"
        ? { division_id: watch("division")?.value }
        : {}),
      ...(role === "DIOS" || role == "District" ? { district_id: watch("district")?.value } : {}),
      ...(mode == "Edit" && { id: watch("id") }),
      ...(role == "Subject Specialist" ? { class_id: watch("class")?.value } : {}),
      ...(role == "Subject Specialist" ? { subject_id: watch("subject")?.value } : {}),
      ...(role == "Subject Specialist" && (watch("class")?.value == 2 || watch("class")?.value == "3")
        ? { stream_id: watch("stream")?.value }
        : {}),
    };

    if (mode == "Add") {
      createLMSAdminAPI(body)
        .then((res) => {
          // decrypt data
          console.log("kjkjkj", res.data);
          const status = res.data.status;
          // const status = decrypt(res.data.status);
          if (status) {
            // const decryptedResponse = decrypt(res.data.data.tableData);
            toast.success(res.data.message);
            setIsOpen(false);
            clearFields();
            getUserList();
          } else if (!status) {
            toast.warning(res.data.message);
          } else if (status === "expired") {
            toast.error(res.data.message);
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }
    if (mode == "Edit") {
      updateLMSAdminAPI(body)
        .then((res) => {
          // decrypt data
          console.log("kjkjkj", res.data);
          const status = res.data.status;
          // const status = decrypt(res.data.status);
          if (status) {
            // const decryptedResponse = decrypt(res.data.data.tableData);
            toast.success(res.data.message);
            setIsOpen(false);
            clearFields();
            getUserList();
          } else if (!status) {
            toast.warning(res.data.message);
          } else if (status === "expired") {
            toast.error(res.data.message);
            logout();
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }

    console.log("body", body);
  };
  const handleEdit = (row) => {
    setValue("row", row);
    window.scrollTo(0, 0);
    setIsOpen(!isOpen);
    setMode("Edit");
    setValue("id", row.id); // Add this for consistent `formData` structure
    setValue("password", row?.password);
    setValue("mobile_no", row?.phoneNumber);
    setValue("name", row?.name);
    setValue("email", row?.email);
    // setValue("role", { value: row?.role, label: row?.role });
    setValue("status", {
      label: row.status == "active" ? "Active" : "Inactive",
      value: row.status == "active" ? "active" : "inactive",
    });
    if (row?.role == "JD" || row?.role == "DIOS" || row?.role == "District" || row?.role == "Division") {
      handleRoleChange({ value: row?.role, label: row?.role });
      handleDivisionChange({ value: row?.division_id, label: row?.division });
      handleDistrictChange({ value: row?.district_id, label: row?.district });
    }
    if (row?.role == "Subject Specialist") {
      handleRoleChange({ value: row?.role, label: row?.role });
      setValue("division", { value: row?.division_id, label: row?.division });
      handleClassChange({ value: Number(row?.class_id), label: row?.class_name });
      handleStreamChange({ value: Number(row?.stream_id), label: row?.stream_name });
      handleSubjectChange({ value: Number(row?.subject_id), label: row?.subject_name });
    }
  };
  const clearFields = () => {
    setValue("name", null); 
    setValue("district", null);
    setValue("districtList", []);
    setValue("division", null);
    setValue("divisionList", []);
    setValue("email", null);
    setValue("mobile_no", null);
    setValue("role", null);
    if (mode == "Add") {
      createPassword();
    }
  };
  const handlePermission = (row) => {
    console.log("handle permission for user", row);
    navigate("/permission", { state: row });
  };
  const getClass = () => {
    const data = {};
    getClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === true) {
          // const decryptedResponse = decrypt(res.data.data.tableData);
          setClassList(res.data.data);
          toast.clearWaitingQueue();
        } else if (status === false) {
          toast.clearWaitingQueue();
          setClassList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          logout();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleClassChange = (selectedOption) => {
    setValue("class", selectedOption || "");
    trigger("class");
    setValue("stream", null);
    setValue("subject", null);
    setValue("name", null);
    const body = {
      class_id: selectedOption?.value,
    };
    if (selectedOption?.value == "1" || selectedOption?.value == "4") {
      getSubjectByClass(body);
    }
    if (selectedOption?.value == "2" || selectedOption?.value == "3") {
      getStreamByClass(body);
    }
  };
  const getSubjectByClass = (body) => {
    setValue("subject", null);
    getSubjectByClassLMSDD(body)
      .then((res) => {
        const status = res.data.status;
        if (status === true) {
          setSubjectList(res.data.data);
        } else if (status === false) {
          setSubjectList([]);
        } else if (status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        console.log("Err", err);
      });
  };
  const getStreamByClass = (data) => {
    setValue("stream", null);
    getStreamByClassDD(data)
      .then((res) => {
        // decrypt data
        const status = res.data.status;
        // const status = decrypt(res.data.status);
        if (status === "expired") {
          toast.error(res.data.message);
          logout();
        } else if (status === true) {
          toast.success(res.data.message);
          setStreamList(res.data.data);
          toast.clearWaitingQueue();
        } else {
          toast.warning(res.data.message);
          setStreamList([]);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  const handleStreamChange = (selectedOption) => {
    setValue("stream", selectedOption || "");
    trigger("stream");
    if (watch("mode") == "Add") {
      setValue("subject", "");
      setValue("chapter", "");
    }
    const body = {
      class_id: watch("class")?.value,
      stream_id: watch("stream")?.value,
    };
    getSubjectByClass(body);
  };
  const handleSubjectChange = (selectedOption) => {
    setValue("subject", selectedOption || "");
    trigger("subject");
    if (watch("role")?.value == "Subject Specialist") {
      setValue("name", `${selectedOption?.label} Subject Specialist ${watch("division")?.label}`);
    }
  };

  return (
    <>
      <Head title="User Management" />
      <Content>
        {!isView ? (
          <div className="p-5" style={{}}>
            <p style={{ color: "crimson", textAlign: "center" }}>{"Unauthorized"}</p>
            <p style={{ textAlign: "center" }}>
              You will be redirected to the home page in <b style={{ color: "crimson" }}>{timer} </b> seconds.
            </p>
          </div>
        ) : (
          <>
            <BlockHead size={`sm`}>
              <BlockBetween>
                <BlockHeadContent>
                  <BlockTitle page tag="h3">
                    {"User Management"}
                  </BlockTitle>
                </BlockHeadContent>
                {isCreate && (
                  <BlockHeadContent>
                    <div>
                      <Button
                        color={`primary`}
                        outline
                        className={`me-n1`}
                        onClick={() => {
                          setIsOpen(!isOpen);
                          setMode("Add");
                          clearFields();
                        }}
                      >
                        <Icon name={isOpen ? "minus" : "plus"} />
                      </Button>
                    </div>
                  </BlockHeadContent>
                )}
              </BlockBetween>
            </BlockHead>
            <Block>
              <Row className={`g-gs`}>
                {isOpen && (
                  <PreviewAltCard>
                    <Form onSubmit={handleSubmit(onFormSubmit)}>
                      <Row className={`g-gs`}>
                        {/* Role */}
                        <Col md={`2`}>
                          <div className="form-group">
                            <Label className="from-label" htmlFor="role">
                              Role
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <Select
                                className=""
                                id="role"
                                options={watch("roleList")}
                                {...register("role", {
                                  required: "Please select role",
                                })}
                                onChange={handleRoleChange}
                                value={watch("role")}
                              />
                              {errors.role && (
                                <span
                                  className="invalid"
                                  style={{
                                    color: "#e85347",
                                    fontSize: "11px",
                                    fontStyle: "italic",
                                  }}
                                >
                                  {errors?.role?.message}
                                </span>
                              )}
                            </div>
                          </div>
                        </Col>
                        {/* Role */}
                        {watch("role")?.value == "IT Admin" ||
                        watch("role")?.value == "State" ||
                        watch("role")?.value == null ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="division">
                                Division
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="division"
                                  options={watch("divisionList")}
                                  {...register("division", {
                                    required: "Please select division",
                                  })}
                                  onChange={handleDivisionChange}
                                  value={watch("division")}
                                />
                                {errors.division && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.division?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* District */}
                        {watch("division") == null ||
                        watch("role")?.value == "JD" ||
                        watch("role")?.value == "Division" ||
                        watch("role")?.value == "IT Admin" ||
                        watch("role")?.value == "Subject Specialist" ||
                        watch("role")?.value == "State" ? null : (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="district">
                                District
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="district"
                                  options={watch("districtList")}
                                  {...register("district", {
                                    required: "Please select district",
                                  })}
                                  onChange={handleDistrictChange}
                                  value={watch("district")}
                                />
                                {errors.district && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.district?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                        {/* Class for  watch("role")?.value == "Subject Specialist" */}
                        {watch("role")?.value == "Subject Specialist" ? (
                          <>
                            {/* Class */}
                            <Col md={`2`}>
                              <div className="form-group">
                                <Label className="from-label" htmlFor="class">
                                  Class
                                  <Required />
                                </Label>
                                <div className="form-control-wrap">
                                  <Select
                                    className=""
                                    id="class"
                                    options={classList}
                                    {...register("class", {
                                      required: "Please select class",
                                    })}
                                    onChange={handleClassChange}
                                    value={watch("class")}
                                  />
                                  {errors.class && <span className="invalid">{errors?.class?.message}</span>}
                                </div>
                              </div>
                            </Col>
                          </>
                        ) : null}
                        {/* Stream */}
                        {(watch("class")?.value == "2" || watch("class")?.value == "3") && (
                          <Col md={`2`}>
                            <div className="form-group">
                              <Label className="from-label" htmlFor="stream">
                                Stream
                                <Required />
                              </Label>
                              <div className="form-control-wrap">
                                <Select
                                  className=""
                                  id="stream"
                                  options={streamList}
                                  {...register("stream", {
                                    required: "Please select stream",
                                  })}
                                  onChange={handleStreamChange}
                                  value={watch("stream")}
                                />
                                {errors.stream && (
                                  <span
                                    className="invalid"
                                    style={{
                                      color: "#e85347",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                    }}
                                  >
                                    {errors?.stream?.message}
                                  </span>
                                )}
                              </div>
                            </div>
                          </Col>
                        )}
                        {watch("role")?.value == "Subject Specialist" ? (
                          <>
                            {/* Subject */}
                            <Col md={`2`}>
                              <div className="form-group">
                                <Label className="from-label" htmlFor="subject">
                                  Subject
                                  <Required />
                                </Label>
                                <div className="form-control-wrap">
                                  <Select
                                    className=""
                                    id="subject"
                                    options={subjectList}
                                    {...register("subject", {
                                      required: "Please select subject",
                                    })}
                                    onChange={handleSubjectChange}
                                    value={watch("subject")}
                                  />
                                  {errors.subject && <span className="invalid">{errors?.subject?.message}</span>}
                                </div>
                              </div>
                            </Col>
                          </>
                        ) : null}
                        {/* First Name */}
                        <Col md="4" sm="3" xxl="3">
                          <div className="form-group">
                            <Label className="from-label" htmlFor="name">
                              {"Name"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter name"}
                                type="text"
                                id="name"
                                {...register("name", {
                                  required:{
                                    validate:true,
                                    message: "Name is required"},
                                   pattern: {
                                    value: /^[a-zA-Z\u0900-\u097F\s]+$/,
                                    message: "Please enter correct the user name.",
                                  },
                                })}
                                className="form-control"
                                value={watch("name")}
                              />
                              {errors.name && <span className="invalid">{errors?.name?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Mobile */}
                        <Col md="4" sm="3" xxl="3">
                          <Label htmlFor="mobile" className="form-label">
                            {"Mobile/Contact"}
                            <Required />
                          </Label>
                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter mobile/contact number"}
                              type="text"
                              id="mobile"
                              {...register("mobile_no", {
                                required: "Mobile number/contact is required",
                              })}
                              className="form-control"
                              value={watch("mobile_no")}
                              onChange={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                setValue("mobile_no", e.target.value);
                                trigger("mobile_no");
                              }}
                              onInput={(e) => {
                                e.target.value = e.target.value.replace(/[^0-9]/g, "");
                                e.target.value = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                              }}
                            />
                            {errors.mobile_no && <span className="invalid">{errors?.mobile_no?.message}</span>}
                          </div>
                        </Col>
                        {/* Email */}
                        <Col md="4" sm="3" xxl="3">
                          <Label htmlFor="email" className="form-label">
                            {"Email"}
                            <Required />
                          </Label>

                          <div className="form-control-wrap">
                            <input
                              placeholder={"Enter email address"}
                              type="text"
                              id="email"
                              {...register("email", {
                                required: "Email address is required",
                                validate: {
                                  isValid: (value) => isValidEmail(value) || "Enter valid email address",
                                },
                              })}
                              className="form-control"
                              value={watch("email")}
                              onChange={(e) => {
                                setValue("email", e.target.value);
                                trigger("email");
                              }}
                            />
                            {errors.email && <span className="invalid">{errors?.email?.message}</span>}
                          </div>
                        </Col>
                        {/* Password */}
                        <Col md="4" sm="3" xxl="3">
                          <div className="form-group">
                            <Label className="from-label" htmlFor="password">
                              {"Password"}
                              <Required />
                            </Label>
                            <div className="form-control-wrap">
                              <input
                                placeholder={"Enter password"}
                                type="text"
                                id="password"
                                {...register("password", {
                                  required: "Password is required",
                                })}
                                className="form-control"
                                value={watch("password")}
                              />
                              {errors.password && <span className="invalid">{errors?.password?.message}</span>}
                            </div>
                          </div>
                        </Col>{" "}
                        {/* Status */}
                        {mode == "Edit" && (
                          <Col md="2" sm="3" xxl="2">
                            <Status
                              setValue={setValue}
                              trigger={trigger}
                              register={register}
                              watch={watch}
                              errors={errors}
                            />
                          </Col>
                        )}
                      </Row>
                      <Col md="2" className={``}>
                        <MyButton isLoading={isLoading} mode={mode} />
                      </Col>
                    </Form>
                  </PreviewAltCard>
                )}

                <MyDataTable data={watch("userList")} columns={columns} isLoading={isLoading} />
              </Row>
            </Block>
          </>
        )}
      </Content>
    </>
  );
};

export default ManageUser;
